import React, { useState } from "react";

import { toast } from "react-toastify";

import { useListarUsuariosPorEquipe } from "services/api/Identity_Usuario";
import { useTransformList } from "hooks/objectToLabelValue";
import { RootStateOrAny, useSelector } from "react-redux";
import { AuthState } from "store/ducks/auth/types";
import { useUsuariosEquipe } from "services/api/Admin_Hierarquia/usuarios-equipe-por-lider";
import { Skeleton, Tooltip } from "@mui/material";
import { useTransferirV1 } from "services/api";
import { useListarUsuariosPorEquipeGerente } from "services/api/Identity_Usuario/listar-usuarios-por-gerente";
import { CARGO_CODES } from "constants/permissions";
import * as IconsSVG from "../../../../assets/iconsSVG";
import images from "../../../../constants/images";

import MaterialUI from "../../../../material-UI";
import axiosLead from "../../../../services/lead";
import handleApiError from "../../../../utils/handleApiError";

import * as Styles from "../../styles";

interface Props {
  leads: [
    {
      idLead: string | undefined;
      idLeadCorretor: string | undefined;
      idCorretorLead: string | undefined;
    }
  ];
  onClose: Function;
  open: boolean;
  hotRefreshFunc: Function;
  transferirTodasPaginas?: boolean;
  idCorretorOrigem?: string;
}

const MultipleTransferByEquipe: React.FC<Props> = ({
  leads,
  onClose,
  open,
  hotRefreshFunc,
  transferirTodasPaginas,
  idCorretorOrigem,
}) => {
  const [value, setValue] = useState({
    label: "",
    value: "",
  });
  const [valueEquipe, setValueEquipe] = useState({
    label: "",
    value: "",
  });
  const { userId, codigoCargo2013 } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );
  const isGerente =
    codigoCargo2013 === CARGO_CODES.GERENTE_VENDAS ||
    codigoCargo2013 === CARGO_CODES.GERENTE_GERAL;
  const [transferCommentCount, setTransferCommentCount] = useState<number>(0);
  const [motivo, setMotivo] = useState<string>("");
  const [isConcluded, setIsConcluded] = useState<boolean>(false);

  const {
    data: dataEquipe,
    refetch: refetchEquipe,
    isRefetching: isRefetchingEquipe,
  } = useUsuariosEquipe(userId);

  const {
    data: dataCorretoresGerente,
    refetch: refetchCorretoresGerente,
    isRefetching: isRefetchingCorretores,
  } = useListarUsuariosPorEquipeGerente({
    queryKey: "listar-corretores-equipe",
    IdUsuarioLider: valueEquipe?.value,
  });

  const {
    data: dataCorretores,
    refetch: refetchCorretores,
    isRefetching,
  } = isGerente
    ? useListarUsuariosPorEquipeGerente({
        queryKey: "listar-corretores-equipe",
        IdUsuarioLider: valueEquipe?.value,
      })
    : useListarUsuariosPorEquipe({
        queryKey: "listar-corretores-equipe",
        IdEquipe: [valueEquipe?.value],
        IdUsuarioLider: [valueEquipe?.value],
      });

  React.useEffect(() => {
    if (codigoCargo2013 === "219.840.000") {
      refetchEquipe();
    }
    if (codigoCargo2013 !== "219.840.000") {
      refetchCorretores();
    }
  }, []);

  React.useEffect(() => {
    if (valueEquipe?.value) {
      refetchCorretores();
      setValue({
        label: "",
        value: "",
      });
    }
    if (!valueEquipe?.value) {
      setValue({
        label: "",
        value: "",
      });
    }
  }, [valueEquipe]);
  console.log(value);
  const handleTransferComment = (comment: string) => {
    setMotivo(comment);
    setTransferCommentCount(comment?.length);
  };
  const { mutate, isLoading, isSuccess } = useTransferirV1({
    leads,
    idCorretorDestino: value.value,
    descricaoMotivoTransferencia: motivo,
    transferirTodasPaginas: !!transferirTodasPaginas,
    idCorretorOrigem,
  });

  const transfLead = async () => {
    try {
      if (value.label === "") {
        toast.warn("Selecione um corretor.");
        return;
      }
      mutate();
    } catch (error: any) {
      handleApiError(error);
    }
  };

  React.useEffect(() => {
    if (isSuccess) {
      setIsConcluded(!isConcluded);
    }
  }, [isSuccess]);

  return (
    <>
      <Styles.TransferComponent>
        {codigoCargo2013 === "219.840.000" ? (
          <Styles.Autocomplete
            id="combo-box-demo"
            disabled={isRefetchingEquipe}
            options={
              dataEquipe
                ? dataEquipe?.map((item: any) => ({
                    label: item.nomeUsuario,
                    value: item.idUsuario,
                  }))
                : []
            }
            value={valueEquipe}
            renderInput={(params: any) => (
              <>
                <Styles.LabelText>Equipe</Styles.LabelText>
                <Styles.TextField
                  placeholder="Selecione a equipe"
                  size="small"
                  InputLabelProps={{ shrink: false }}
                  variant="outlined"
                  {...params}
                  label="Corretor de destino"
                />
              </>
            )}
            getOptionLabel={(option: any) => option.label || ""}
            onChange={(event, newValue: any) => {
              setValueEquipe(newValue);
            }}
          />
        ) : (
          <></>
        )}

        <br />
        {isRefetching ? (
          <Skeleton variant="rounded" width="auto" height="2.5rem" />
        ) : (
          <Styles.Autocomplete
            id="combo-box-demo"
            disabled={isRefetching}
            options={
              dataCorretores?.data
                ? dataCorretores?.data?.map((item: any) => ({
                    label: item.apelido,
                    value: item.idCorretor,
                  }))
                : []
            }
            value={value}
            renderInput={(params: any) => (
              <>
                <Styles.LabelText>Corretor de destino</Styles.LabelText>
                <Styles.TextField
                  placeholder="Selecione o corretor"
                  size="small"
                  InputLabelProps={{ shrink: false }}
                  variant="outlined"
                  {...params}
                  label="Corretor de destino"
                />
              </>
            )}
            getOptionLabel={(option: any) => option.label || ""}
            onChange={(event, newValue: any) => {
              if (newValue) {
                setValue(newValue);
              } else {
                setValue({
                  label: "",
                  value: "",
                });
              }
            }}
          />
        )}
        <Styles.MultLineField>
          <Styles.LabelText>Motivo</Styles.LabelText>
          <Styles.TextField
            onChange={(e: any) => handleTransferComment(e.target.value)}
            label="Multiline"
            variant="outlined"
            fullWidth
            multiline
            minRows={3}
            defaultValue="Default Value"
            value={motivo}
            inputProps={{ maxLength: 500 }}
          />
          <Styles.CountText>{transferCommentCount}/500</Styles.CountText>
        </Styles.MultLineField>
      </Styles.TransferComponent>
      <Styles.Footer>
        <Styles.FooterDialog>
          <Styles.Button variant="outlined" onClick={() => onClose(!open)}>
            Cancelar
          </Styles.Button>
          <Tooltip
            title="Selecione um corretor de destino para transferir"
            placement="top"
            followCursor
            arrow
          >
            <Styles.Button
              className="transfer-btn"
              color="secondary"
              variant="contained"
              style={{ opacity: !value?.value ? 0.7 : 1 }}
              disabled={!value?.value || isLoading}
              onClick={transfLead}
            >
              {isLoading ? <MaterialUI.CircularProgress /> : "Transferir"}
            </Styles.Button>
          </Tooltip>
        </Styles.FooterDialog>
      </Styles.Footer>
      {isConcluded && (
        <Styles.ContainerConfirm>
          <Styles.HeaderContent>
            <Styles.BoxImgSuccess>
              <IconsSVG.SuccessIcon />
            </Styles.BoxImgSuccess>
            <Styles.HeaderTitle>Leads transferidos</Styles.HeaderTitle>
          </Styles.HeaderContent>
          <Styles.InfoContent>
            <Styles.TitleInfo>
              Estes leads não serão mais exibidos na sua carteira
            </Styles.TitleInfo>
            <Styles.BoxImgArt>
              <img src={images.transferSuccessArt} alt="Art Success" />
            </Styles.BoxImgArt>
            <Styles.LinkReturn
              onClick={() => {
                hotRefreshFunc();
                onClose(!open);
                setIsConcluded(!isConcluded);
              }}
            >
              Voltar para a carteira
            </Styles.LinkReturn>
          </Styles.InfoContent>
        </Styles.ContainerConfirm>
      )}
    </>
  );
};

export default MultipleTransferByEquipe;
